<template>
	<div class="iframe-content" style="background-color: #FFFFFF;
      ">
		<form name="form1" id="form1" style="padding:0;" class="form form-horizontal" method="post"
			enctype="multipart/form-data">
			<div class="formTitleSD" style="color: #414658;font-size: 16px;font-weight: bold;">
				<span v-if="pageType==1">添加</span>
				<span v-if="pageType==2">编辑</span>
				<span v-if="pageType==3">查看</span>
				模板
			</div>
			<div class="formDivSD" style="margin: 0 auto;width: 50%;padding-top: 30px;">
				<div class="row cl" style="margin-top: 40px;">
					<label class="form-label col-2" style="margin-top: 7px;"><span class="c-red">*</span>模板名称：</label>
					<div class="formControls col-6">

						<el-input v-model="freightName" style="" :disabled="pageType == 3"></el-input>
					</div>
				</div>
				<div class="row cl" style="margin-top: 20px;">
					<label class="form-label col-2" style="margin-top: 7px;"><span class="c-red">*</span>计算方式：</label>
					<div class="formControls col-6">
						<el-select @change="typeChanged" :disabled="pageType == 3" v-model="freightLabel"
							style="width:100%" clearable>
							<el-option v-for="(item,index) of mountedType" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</div>
				</div>
				<div class="row cl" style="margin-top: 20px;">
					<label class="form-label col-2" style="margin-top: 7px;"><span class="c-red">*</span>模板规则：</label>
					<div class="formControls col-2" style="">



						<el-button @click="choice()" type="primary" size="small" :disabled="pageType == 3">添加规则
						</el-button>
						<el-table v-if="mould.length > 0" :data="mould" element-loading-text="拼命加载中..." ref="table"
							:header-cell-style="table_style" class="el-table" style="width: 100%;margin-top: 20px">
							<el-table-column v-if="freightType == 1" label="运费(元)" align="center" key="1">
								<template scope="scope">
									<el-input style="width: 53px" :disabled="pageType == 3" v-model="scope.row.freight"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>

							<el-table-column v-if="freightType == 2" label="首件数量" align="center" key="2">
								<template scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.firstWight"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="freightType == 2" label="首件运费(元)" align="center" key="3">
								<template scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.firstFreith"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="freightType == 2" label="续件数量" align="center" key="4">
								<template :span="2" scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.nextWight"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="freightType == 2" label="续件运费(元)" align="center" key="5">
								<template scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.nextFreit"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="freightType == 3" label="首件重量(kg)" align="center" key="6">
								<template scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.firstWight"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="freightType == 3" label="首件运费(元)" align="center" key="7">
								<template scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.firstFreith"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="freightType == 3" label="续件重量(kg)" align="center" key="8">
								<template :span="2" scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.nextWight"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="freightType == 3" label="续件运费(元)" align="center" key="9">
								<template scope="scope">
									<el-input :disabled="pageType == 3" v-model="scope.row.nextFreit"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column min-width="150" label="省份" align="center">
								<template scope="scope">
									<span>{{scope.row.province}}</span>
								</template>
							</el-table-column>
							<el-table-column v-if="pageType != 3" label="操作" class-name="cz" align="center" fixed="right" width="150">
								<template slot-scope="scope">
									<div class="tableScope" style="justify-content: center;">
										<div v-if="scope.row.statu != 0" class="tableScopeHr"></div>

										<template>
											<el-button size="mini" icon="el-icon-edit-outline" @click="editMould(scope.$index)">
												编辑
											</el-button>
											<div class="tableScopeHr"></div>
										</template>
										<el-button size="mini" icon="el-icon-circle-close" @click="delMould(scope.$index)">删除
										</el-button>

									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="row cl" style="margin-top: 20px;">
					<label class="form-label col-2" style="margin-top: unset;"><span class="c-red"></span>包邮设置：</label>
					<div class="formControls col-6" style="">
						<el-switch :disabled="pageType == 3" active-value="1" inactive-value="0"
							v-model="free_shipping_open" active-color="#13ce66" inactive-color="#EBEBF9">
						</el-switch>
						<div style="background:#F4F7F9;margin-top: 20px;padding: 5px 15px;"
							v-if="free_shipping_open =='1' ">
							<div class="free_shipping">
								&nbsp;&nbsp;同件商品, 满&nbsp;&nbsp;<el-input v-model="reachNumber" style="width: 53px"
									:disabled="pageType == 3" size="mini"></el-input>&nbsp;&nbsp;件, 包邮
							</div>

						</div>
						<div>
						</div>
					</div>
				</div>

				<div class="row cl" style="margin-top: 20px;margin-bottom: 20px;">
					<label class="form-label col-2" style="margin-top: unset;"><span
							class="c-red"></span>指定不配送设置：</label>
					<div class="formControls col-6" style="">
						<el-switch @change="free_shipping_change" :disabled="pageType == 3" active-value="1"
							inactive-value="0" v-model="not_delivery_open" active-color="#13ce66"
							inactive-color="#EBEBF9">
						</el-switch>
						<div style="margin-top: 21px;background: #F4F7F9;padding: 15px 15px;"
							v-if="not_delivery_open == '1'">
							<span style="margin-right: 5px;">选择区域</span>
							<el-cascader @visible-change="modeChange" :disabled="pageType == 3"
								v-model="not_deliveryProvince_select" placeholder="请输入关键字" :options="not_deliver_area"
								:props="multiple_prop" filterable>
							</el-cascader>
						</div>
					</div>
				</div>

				<div class="row cl" style="margin-top: 20px;margin-bottom: 150px;">
					<label class="form-label col-2"><span class="c-red"></span></label>
					<div class="formControls col-2">
						<div class="formInputSD upload-group multiple" style="margin: 2px 0px 12px;display: unset;"
							v-if="pageType != 3">
							<div class="formTextSD" style="min-width: 120px;"><span style="color:red"></span></div>
							<el-button type="primary" class="footer-save" @click="save_freight()">保存</el-button>
							<el-button plain class="footer-cancel" onclick="javascript:history.back(-1);">取消</el-button>
						</div>
						<div class="formInputSD upload-group multiple" style="margin: 2px 0px 12px;display: unset;"
							v-if="pageType == 3">
							<div class="formTextSD" style="min-width: 120px;"><span style="color:red"></span></div>
							<el-button plain class="footer-cancel" onclick="javascript:history.back(-1);">返回</el-button>
						</div>
					</div>
				</div>



				<div class="formInputSD">
					<input type="hidden" name="url" class="input-text" value="{$page_url}" id="title"
						style="width: 380px;">
					<input type="hidden" name="type0" class="input-text" value="{$type0}" id="title"
						style="width: 380px;">
				</div>
			</div>
		</form>
		<div class="row cl" style="display: flex;">
			<label class="form-label col-2"></label>
			<div class="formControls col-2" style="flex: 1;">
				<div class='row cl' id='information' style='width: 80%;display: none;'>
					<input type="hidden" class="input-text" value="" name="hidden_freight" id="hidden_freight">
					<table class='table table-border table-bordered table-bg' style='width: 98%;margin-left: 20px;'>
						<thead id="thead_freight">
							<tr>
								<th style=" width: 118px;text-align: center">运费</th>
								<th style="width: 800px;text-align: center">省份</th>
								<th style="width: 118px;text-align: center">操作</th>
							</tr>
						</thead>
						<tbody id="tbody_freight">

						</tbody>
					</table>
				</div>

			</div>
		</div>

		<div style="height: 70px;"></div>


		</form>

		<div class="row keep" style="display: none;z-index: 9999;"></div>
		<div class="pop_model" style="display: none;z-index: 9999;">
			<div class="row php_title">
				<span>添加运费规则</span>
				<a href="javascript:void(0);" class="closeA" @click=select_hid()
					style="display: flex; align-items: center;"><img :src="delImg" /></a>
			</div>
			<div class="inner_container" id="style-4">

				<div class="row cl content" style="display: flex;margin-top: 3px;">
					<label class="form-label " style="width: 122px!important;font-size: 15px;"><span class="c-red"
							style="color:red;">*</span>选择省份：</label>
					<div class="formControls skin-minimal" style="flex: 1;display: flex; flex-wrap: wrap;">
						<el-checkbox style="width: 100%;margin: 0 0 10px 6px;" :indeterminate="isIndeterminate"
							v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
						<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
							<el-checkbox @change="getcheckItem(item)" v-for="(item,index) in not_deliveryProvince"
								:label="item.GroupID">{{item.G_CName}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="row cl"
					style="padding: 16px 0; display: flex; justify-content: flex-end; margin: 0; position: absolute; bottom: 0; left: 0; right: 0;border-top: 1px solid #E9ECEF;">
					<button class="btn btn-primary radius"
						style="width: 112px;height: 36px;border-radius: 2px;border: 1px solid #2890FF;color: #2890FF;background: #FFFFFF!important;margin-right: 10px;"
						type="button" @click="select_hid()">取消
					</button>
					<button class="btn btn-primary radius"
						style="width: 112px;height: 36px;border-radius: 2px;border: 1px solid #2890FF;color: #2890FF;background: #FFFFFF!important;margin-right: 10px;"
						type="button" @click="save_address(freightIndex)">添加
					</button>

				</div>
			</div>
		</div>

	</div>
</template>
<style scoped lang="less">
	@import url('../../assets/css/addconfig.less');
</style>
<script>
	import {
		arrCopy
	} from '../../lib/tool'
	import {
		imgURL
	} from '../../lib/config.js'

	function sel_all() {
		if ($("#sex-all").get(0).checked) {
			//全选
			$("input[type='checkbox']").prop("checked", true);
		} else {
			//全不选
			$("input[type='checkbox']").prop("checked", false);
		}
	}


	export default {
		data() {
			return {
				checkAll: false,
				checkedCities: [],
				checkarr: [],
				isIndeterminate: true,
				checkList: [],
				not_deliveryProvince: [], //
				not_deliver_area: [], // 不配送区域
				provinceList: [],
				freightIndex: "添加",
				not_deliveryProvince_select: [],
				freightName: '',
				delImg: imgURL + 'images/icon1/gb.png',
				pageType: "1", // 1是添加 2是修改 3.是查看
				freightLabel: "默认",
				freightType: 1,
				freight_rule: '2',
				table_style: {
					background: '#F4F7F9'
				},
				multiple_prop: {
					value: 'GroupID',
					label: 'G_CName',
					multiple: true
				},
				free_shipping_open: true,
				reachNumber: '',
				reachMoney: '',
				reachWeight: '',
				not_delivery_open: 1,
				mouldId: '', // 模板id
				// 1.分类 2.商品 3.店铺
				mouldName: ['首件重量', '首件运费', '续件重量', '续件运费', '省份'],
				mould: [],
				defaultMould: [ // 默认模板
					{
						value: '1',
						label: '图片'
					},
					{
						value: '2',
						label: '视频'
					}

				],
				numberMould: [ // 件数模板
					{
						value: '1',
						label: '图片'
					},
					{
						value: '2',
						label: '视频'
					}

				],
				weightMould: [ // 重量模板
					{
						value: '1',
						label: '图片'
					},
					{
						value: '2',
						label: '视频'
					}

				],
				mountedType: [ // 计算方式
					{
						value: '1',
						label: '默认'
					},
					{
						value: '2',
						label: '件数'
					},
					{
						value: '3',
						label: '重量'
					}

				],
			}

		},
		created() {
			let a = $(".aside_right")
			this.freightType = 1;
			if (this.$route.query.pageType != undefined) {
				this.pageType = this.$route.query.pageType
			}
			if (this.$route.query.id != undefined) {
				this.mouldId = this.$route.query.id
			}


			console.log(this.$route.query.pageType)
			console.log(this.pageType)
			// 获取省
			this.getAllProvince();
			this.getDataById(this.mouldId);
			// 根据id获取模板数据
		},

		mounted() {
			this.url = $('input[name="url"]').val();
			// this.type0 =  $('input[name="type0"]').val();
		},
		watch: {

			mould(newData, oldData) {
				let selectStr = '';

			}
		},
		methods: {
			free_shipping_change(val) {
				if (val == 0) {
					this.not_deliveryProvince_select = [];
				}
			},
			getcheckItem(item) {
				console.log(item)
				if (this.checkarr.indexOf(item.G_CName) == -1) {
					this.checkarr.push(item.G_CName);
				} else {
					this.checkarr.splice(this.checkarr.indexOf(item.G_CName), 1);
				}
				console.log('this.name.--', this.checkarr)

			},
			handleCheckAllChange(val) {
				console.log(val)
				var checkarr = []
				var checkedCitiesId = [];
				if(val){
					this.not_deliveryProvince.forEach(item => {
						checkedCitiesId.push(item.GroupID)
						this.checkarr.push(item.G_CName);
					})
				}else{
					checkarr = []
					this.checkarr = [];
				}
				this.checkedCities = val ? checkedCitiesId : [];
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				console.log(value)
				let checkedCount = value.length;
				console.log(checkedCount)
				this.checkAll = checkedCount === this.not_deliveryProvince.length;
				console.log(this.checkAll)
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.not_deliveryProvince.length;
			},
			select_hid() {
				$('.keep').hide();
				$('.pop_model').hide();
			},
			getDataById(id) {
				var that = this;
				that.not_deliveryProvince_select = [];
				let data = {
					id: this.mouldId,

				};
				this.$request.post("index.php?module=pc_api&action=freight&m=edit_page", data).then(res => {

					if (res.code == 200) {
						that.freightName = res.data.name
						that.mould = res.data.freight
						that.free_shipping_open = res.data.is_package_settings
						that.reachNumber = res.data.package_settings
						that.freightType = res.data.type
						that.freightLabel = res.data.type
						that.not_delivery_open = res.data.is_no_delivery
						that.not_deliveryProvince_select = res.data.no_delivery

						//that.not_deliver_area = res.data.no_delivery

					}
					that.modeChange(1)
					console.log(that.not_deliveryProvince_select)

				});
			},
			onChange() {
				this.url = '';
			},
			getAllProvince() {
				var that = this;
				this.$request.post("index.php?module=pc_api&action=freight&m=get_sheng", {
					data: [],
					sel_city: []
				}).then(res => {
					if (res.code == 200) {
						that.provinceList = res.data;

						that.not_deliveryProvince = res.data;
					}
				})
			},

			delMould(dataIndex) {
				this.mould.splice(dataIndex, 1)
			},
			editMould(dataIndex) {
				this.checkarr = []
				this.checkedCities = []
				this.freightIndex = dataIndex;

				let cityValue = this.mould[dataIndex].city_value

				var citySelectArr = cityValue.split(',');
				$('#first_weight').val('')
				var type = $('input:radio:checked').val();

				$('#first_fee').val(0)
				$('#weight_continuation_freight').val(0)
				$('#freight').val(0)
				$('#piece_continuation_freight').val(0)

				var data;

				var rew = '';

				var sel_city1 = []


				let selectStr = '';
				//已经选择的省
				this.mould.forEach(function(item, index) {

					if (index != dataIndex) {
						selectStr = selectStr + ',' + item.city_value
					}
				})
				// 不发货城市设置
				this.not_deliveryProvince_select.forEach(function(item, index) {


					selectStr = selectStr + item[0]
				})

				sel_city1 = selectStr.split(',')

				this.$request.post("index.php?module=pc_api&action=freight&m=get_sheng", {
					data: data,
					sel_city: sel_city1
				}).then(res => {
					if (res.code == 200) {

						var list = res.data;
						this.not_deliveryProvince = res.data;

						rew +=
							" <div class='radio-box' style='display: flex; width: 138px; align-items: center;padding-left:6px;margin-right:300px;margin-top: 1px;'><input name='all' class='inputC' type='checkbox' id='sex-all' onchange='sel_all'><label style='margin-left: 7px;' for='sex-all'>全选</label></div>" +
							"<br>";
						for (var k in list) {
							rew +=
								"<div class='radio-box' style='margin:6px 0;display: flex; width: 138px; align-items: center;padding-left:6px'>"
							if ($.inArray(list[k].GroupID, citySelectArr) != -1) {
								rew += "<input name='list' class='inputC' data-name='" + list[k]['G_CName'] +
									"' type='checkbox' checked='checked' id='sex-" + list[k]['GroupID'] +
									"' value='" + list[k]['GroupID'] + "'>"
							} else {
								rew += "<input name='list' class='inputC' data-name='" + list[k]['G_CName'] +
									"' type='checkbox'  id='sex-" + list[k]['GroupID'] + "' value='" + list[k][
										'GroupID'
									] + "'>"
							}
							rew += "<label style='margin-left: 7px;' for='sex-" + list[k]['GroupID'] + "'>" + list[
									k]['G_CName'] + "</label>" +
								"</div>"
						}
						rew += "<script> var sel_all =function() {" +
							"if ($('#sex-all').get(0).checked) {" +
							//全选
							"$('input[type=\'checkbox\']').prop('checked', true);" +
							"} else {" +
							//全不选
							"$('input[type=\"checkbox\"]').prop('checked', false);" +
							"}" +
							"}" + "<\/script>"


						// document.getElementById("province1").innerHTML = rew;
						$('.keep').show();

						$('.pop_model').show();
						if (type == 0) {
							$('.piece').show();
							$('.weight').hide();
						} else {
							$('.weight').show();
							$('.piece').hide();
						}
					} else {
						parent.VM.$message.error("添加失败，地区运费规则已全部设置!");
					}
				});
			},
			typeChanged(val) {
				console.log(val)
				this.mould = [];
				this.freightType = val;
			},
			save_freight() {

				let data = {
					name: this.freightName,
					type: this.freightType,
					hidden_freight: JSON.stringify(this.mould),
					is_package_settings: this.free_shipping_open,
					package_settings: this.reachNumber,
					is_no_delivery: this.not_delivery_open,
					no_delivery: JSON.stringify(this.not_deliveryProvince_select),
				};
				if (this.pageType == 2) {
					data.id = this.mouldId
					var url = 'index.php?module=pc_api&action=freight&m=edit';
				} else if (this.pageType == 1) {
					var url = 'index.php?module=pc_api&action=freight&m=add';
				}

				this.$request.post(url, data).then(res => {
					if (res.code == 200) {
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message);
					}
					if (res.code == 200) {
						// this.$router.push({
						// 	path: 'goodsmanage/config'
						// })
						this.$router.go(-1)
					}
				})

			},
			save_address() { // 添加编辑规则

				var that = this;

				console.log(this.not_deliveryProvince_select);

				var obj = document.getElementsByName("list");
				var check_val = [];
				var city_str = this.checkedCities.join(",");
				var city_name = this.checkarr.join(",")
				// for ( let k in obj) {
				//     if (obj[k].checked) {
				//         check_val.push(obj[k].value);
				//         city_str = city_str + obj[k].value + ',';
				//         city_name +=  obj[k].dataset.name + ',';
				//     }
				// }
				console.log(this.checkedCities)
				// this.checkedCities.forEach(item=>{

				// 	city_str = city_str + item.GroupID + ',';
				// 	city_name +=  item.G_CName + ',';
				// })

				if (this.checkedCities.length == 0) {
					this.$message.error('请选择省份！');
					return
				}

				if (this.freightIndex == "添加") {
					if (this.freightType == 1) {

						var data = {
							freight: '0', // 运费
							province: city_name, //省份名称
							city_value: city_str //省份值
						}

					} else if (this.freightType == 2) {

						var data = {
							firstWight: '0', // 首件数量
							firstFreith: '0', // 首件运费
							nextWight: '0', // 续件重量
							nextFreit: '0', //续件运费
							province: city_name, //省份
							city_value: city_str //省份
						}
					} else if (this.freightType == 3) {

						var data = {
							firstWight: '0', // 首件重量
							firstFreith: '0', // 首件运费
							nextWight: '0', // 续件重量
							nextFreit: '0', //续件运费
							province: city_name, //省份
							city_value: city_str //省份
						}
					}

					this.mould.push(data)
				} else {
					this.mould.forEach(function(item, i) {
						if (i == that.freightIndex) {
							that.mould[that.freightIndex].province = city_name;
							that.mould[that.freightIndex].city_value = city_str;
						}
					})
				}




				$(".pop_model").hide();
				$(".keep").hide();

			},
			modeChange(val) {
				var that = this;
				if (val) {
					let selectStr = '';
					let sel_city1 = [];
					//已经选择的省
					this.mould.forEach(function(item, index) {

						selectStr = selectStr + ',' + item.city_value;
					})
					sel_city1 = selectStr.split(',')
					this.$request.post("index.php?module=pc_api&action=freight&m=get_sheng", {
						sel_city: sel_city1
					}).then(res => {
						if (res.code == 200) {
							that.not_deliver_area = res.data;
						}

					});
				}
			},
			choice() {
				this.checkarr = []
				this.checkAll = []
				this.checkedCities = []
				this.freightIndex = "添加",
					$('#first_weight').val('')
				var type = $('input:radio:checked').val();

				$('#first_fee').val(0)
				$('#weight_continuation_freight').val(0)
				$('#freight').val(0)
				$('#piece_continuation_freight').val(0)

				// var data;
				// if (freight_num == 0) {
				//     data = '';
				// } else {
				//     var hidden_freight = document.getElementById("hidden_freight").value;
				//     data = hidden_freight;
				// }
				var rew = '';

				var sel_city1 = []

				let selectStr = '';

				//已经选择的省
				this.mould.forEach(function(item, index) {

					selectStr = selectStr + ',' + item.city_value;
				})
				// 不发货城市设置
				this.not_deliveryProvince_select.forEach(function(item, index) {


					selectStr = selectStr + ',' + item[0];
				})
				sel_city1 = selectStr.split(',')

				this.$request.post("index.php?module=pc_api&action=freight&m=get_sheng", {
					sel_city: sel_city1
				}).then(res => {
					console.log(res)

					if (res.code == 200) {
						var list = res.data;

						this.not_deliveryProvince = res.data;
						rew +=
							" <div class='radio-box' style='display: flex; width: 138px; align-items: center;padding-left:6px;margin-right:300px;margin-top: 1px;'><input name='all' class='inputC' type='checkbox' id='sex-all' onchange='sel_all'><label style='margin-left: 7px;' for='sex-all'>全选</label></div>" +
							"<br>";
						for (var k in list) {
							rew +=
								"<div class='radio-box' style='margin: 6px 0;display: flex; width: 138px; align-items: center;padding-left:6px'>" +
								"<input name='list' class='inputC' data-name='" + list[k]['G_CName'] +
								"' type='checkbox' id='sex-" + list[k]['GroupID'] + "' value='" + list[k][
									'GroupID'] + "'>" +
								"<label style='margin-left: 7px;' for='sex-" + list[k]['GroupID'] + "'>" + list[k][
									'G_CName'
								] + "</label>" +
								"</div>"
						}

						rew += "<script> var sel_all = function() {" +

							"}" + "<\/script>"
						// document.getElementById("province1").innerHTML = rew;
						function sel_all() {
							console.log(3666)
							if ($("#sex-all").get(0).checked) {
								//全选
								$("input[type='checkbox']").prop("checked", true);
							} else {
								//全不选
								$("input[type='checkbox']").prop("checked", false);
							}
						}
						$('.keep').show();
						$('.pop_model').show();
						if (type == 0) {
							$('.piece').show();
							$('.weight').hide();
						} else {
							$('.weight').show();
							$('.piece').hide();
						}
					} else {
						parent.VM.$message.error("添加失败，地区运费规则已全部设置!");
					}
				});
			},
			getQueryVariable(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			}


		}
	}
</script>

<style lang="less">
	.ant-layout-content {
	  overflow-y: scroll;
	}
	
</style>
